import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useProjectTitle } from "../../../ducks/project/hooks";
import { getPrintTitle } from "../../../ducks/print/selectors";

const PRINT_FILE_EXTENSION = "png";

export const usePrintFileFormat = () => {
  const projectTitle = useProjectTitle();
  const printTitle = useSelector(getPrintTitle);
  const title = printTitle || projectTitle;

  return useMemo(
    () => ({
      name: (title && title.replace(/\s/g, "")) || "",
      ext: PRINT_FILE_EXTENSION,
    }),
    [title],
  );
};
